import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { get } from '../../../lib/api';

const useGetAccountSettings = () => {
  const initialData = {
    notificationPrefOptions: {},
    notificationPreference: '',
    privacyLevel: '',
    presentationEmail: '',
    phoneNumber: '',
    canChangePassword: false,
    canInviteDependents: false,
    canAddDependent: false,
    dependentBoardEmailSubject: '',
    dependentBoardEmailBody: '',
    existingDependent: null,
  };

  const { data, refetch } = useQuery(
    ['accountSettings'],
    () => get('/api/account_settings'),
    { initialData, enabled: false },
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  return data;
};

export default useGetAccountSettings;
